import React, { useEffect, useState } from 'react';
import DistributorProductAccess from './DistributorProductAccess';
import DistributorPurchaseSettings from './DistributorPurchaseSettings';
import DistributorAccountingSettings from './DistributorAccountingSettings';

/** One setup location; an unfinished edit locks the neighboring configuration panels. */
export default function DistributorPurchaseConfiguration({
  distributor,
  disabled,
  onLockChange,
  workspaceAdmin = false,
  cashMode = false,
  legacyAvailable = true,
}) {
  const [productLocked, setProductLocked] = useState(false);
  const [purchaseLocked, setPurchaseLocked] = useState(false);
  const [accountingLocked, setAccountingLocked] = useState(false);
  useEffect(() => {
    onLockChange(purchaseLocked || accountingLocked || productLocked);
    return () => onLockChange(false);
  }, [purchaseLocked, accountingLocked, productLocked, onLockChange]);
  return (
    <>
      <DistributorProductAccess
        distributor={distributor}
        disabled={disabled || purchaseLocked || accountingLocked}
        onLockChange={setProductLocked}
      />
      {legacyAvailable && !cashMode && (
        <DistributorPurchaseSettings
          workspaceAdmin={workspaceAdmin}
          distributor={distributor}
          disabled={disabled || accountingLocked || productLocked}
          onLockChange={setPurchaseLocked}
        />
      )}
      {legacyAvailable && !cashMode && (
        <DistributorAccountingSettings
          distributor={distributor}
          disabled={disabled || purchaseLocked || productLocked}
          onLockChange={setAccountingLocked}
        />
      )}
    </>
  );
}
